import React from "react";

const NoDataSkeleton = (props: {
  message?: string;
  ltc?: boolean;
  school?: boolean;
}) => {
  const { message, ltc = false, school = false } = props;
  return (
    <div className="h-100 w-100 d-flex flex-column justify-content-center align-items-center">
      <i className="fas fa-robot h1"></i>
      <h5 className="text-center w-50">
        {message ?? ltc
          ? "The data is being suppressed to protect the identities of people that live / work in this facility."
          : school
          ? "The data is being suppressed to protect the identities of people who attend / work at this school."
          : "The data is being suppressed to protect the identities of people that live in this area."}
      </h5>
    </div>
  );
};

export default NoDataSkeleton;
